<div class="tag" *ngIf="firstAvailableLabel$ | async">
  {{ firstAvailableLabel$ | async }}
</div>
